
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import OrderList from './pages/OrderList';
import CreateOrder from './pages/CreateOrder';
import RequestPickup from './pages/RequestPickup';
import CheckServicibility from './pages/CheckServicibility';
import ManageWarehouse from './pages/ManageWarehouse';
import Success from './pages/Success';
import CreateUser from './pages/CreateUser';
import Users from './pages/Users';
import Login from './pages/Login';
import { useSelector, useDispatch } from "react-redux"
import { useEffect } from 'react';
import { loadUser } from './actions/userActions';
import EditUser from './pages/EditUser';
import Profile from './pages/Profile';
import UpdateProfile from './pages/UpdateProfile';
import ViewOrder from './pages/ViewOrder';
import UserDetailsAdmin from './pages/UserDetailsAdmin';
import CreateStaff from './pages/CreateStaff';
import AdminSignup from './pages/AdminSignup';
import CreateDeliveryOrder from './pages/CreateDeliveryOrder';
import PickupBoyList from './pages/PickupBoyList';
import DeliveryBoyList from './pages/DeliveryBoyList';
import EditOrder from './pages/EditOrder';
import DigitalLR from './pages/DigitalLR';
import CreateBranch from './pages/CreateBranch';
import ShippinglabelAdmin from './pages/ShippinglabelAdmin';
import ManageDelivery from './pages/ManageDelivery';
import DeliveryBoyDataList from './pages/DeliveryBoyDataList';
import EditWarehouse from './pages/EditWarehouse';
import PartnerList from './pages/PartnerList';
import BulkOrderUpload from './pages/BulkOrderUpload';
import BulkWaybillDownload from './pages/BulkWaybillDownload';
function App() {
  const { error, loading, isAuthenticated, users, userProfile } = useSelector(
    (state) => state.user
  );
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch();
  const deliveryRoles = ['Delivery Boy', 'Delivery Partner'];
  const isDeliveryUser = isAuthenticated && deliveryRoles.includes(userProfile?.role);
  const isAdmin = isAuthenticated && userProfile?.role === 'admin';
  const isLogisticsUser = isAuthenticated && userProfile?.service === 'logistics' && !isDeliveryUser;
  const canUseDashboard = isAdmin || isLogisticsUser || isDeliveryUser;
  useEffect(() => {
    if (isAuthenticated && !userProfile) {
      dispatch(loadUser(users));
    }
    if (!isAuthenticated) {
      const publicPaths = ['/login', '/adminsignup']
      if (!publicPaths.includes(location.pathname)) {
        navigate("/login")
      }
    }
  }, [isAuthenticated, location.pathname])
  return (
    <div className="App">
      <Routes>
        {canUseDashboard && <Route exact path="/" element={<Home />} />}
        <Route exact path="/login" element={<Login />} />
        {(isAdmin || isLogisticsUser) && <Route exact path="/orders" element={<OrderList />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/manageDelivery" element={<ManageDelivery />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/DeliveryBoyDataList" element={<DeliveryBoyDataList />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/orderDetails/shippinglabel/:id" element={<ShippinglabelAdmin />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/createBranch" element={<CreateBranch />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/orderDetails/:id" element={<ViewOrder />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/orderDetails/waybill/:id" element={<DigitalLR />} />}
        {(isAdmin || isLogisticsUser || (isAuthenticated && userProfile?.role === "Operational Manager")) && <Route exact path="/editorder/:id" element={<EditOrder />} />}
        {(isAdmin || isLogisticsUser || (isAuthenticated && userProfile?.role === "Operational Manager")) && <Route exact path="/editwarehouse/:id" element={<EditWarehouse />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/create-order" element={<CreateOrder />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/bulk-order-upload" element={<BulkOrderUpload />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/bulk-waybill-download" element={<BulkWaybillDownload />} />}
        {isDeliveryUser && <Route exact path="/createDelivery" element={<CreateDeliveryOrder />} />}
        {isDeliveryUser && <Route exact path="/pickupList" element={<PickupBoyList />} />}
        {isDeliveryUser && <Route exact path="/deliveryList" element={<DeliveryBoyList />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/request-pickup" element={<RequestPickup />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/partnerlist" element={<PartnerList />} />}
        {canUseDashboard && <Route exact path="/servicibility" element={<CheckServicibility />} />}
        {(isAdmin || isLogisticsUser) && <Route exact path="/warehouse" element={<ManageWarehouse />} />}
        <Route exact path="/adminsignup" element={<AdminSignup />} />
        {isAdmin && <Route exact path="/create-user" element={<CreateUser />} />}
        {isAdmin && <Route exact path="/create-staff" element={<CreateStaff />} />}
        {isAdmin && <Route exact path="/users" element={<Users />} />}
        {isAdmin && <Route exact path="/users/:id" element={<EditUser />} />}
        {isAdmin && <Route exact path="/user/:id" element={<UserDetailsAdmin />} />}
        <Route exact path="/success" element={<Success />} />
        {canUseDashboard && <Route exact path="/profile" element={<Profile />} />}
        {canUseDashboard && <Route exact path="/updateProfile" element={<UpdateProfile />} />}
        <Route exact path="*" element={<Success />} />
      </Routes>
    </div>
  );
}

export default App;
